import React, { Fragment } from 'react'
import { SelectedFilters, Filters } from '../Filters'
import PropTypes from 'prop-types'

import '@loyal_molecules/accordion.css'

const Sidebar = ({
  categories,
  handleFilterChanged,
  filterSelected,
  priceLimit,
  pageType,
  isLoading,
  className,
  ordination,
  showZipCode
}) => {
  const mustShow =
    filterSelected &&
    (filterSelected.zipcode ||
    (filterSelected.category && filterSelected.category.length > 0))

  return (

    <Fragment>
      <div
        className={`container-siderbar filterSelected col-12 ${className ||
            ''}`}
      >
        {mustShow ? (
          <SelectedFilters
            filterSelected={filterSelected}
            categories={categories}
            handleFilterChanged={handleFilterChanged}
            pageType={pageType}
          />

        ) : null}
      </div>

      <div
        className={`container-sidebar col-12 col-md-4 col-lg-3 pb-5 px-1 px-md-2 mb-5 mt-2 ${className || ''}`}>
        <Filters
          categories={categories}
          handleFilterChanged={handleFilterChanged}
          filterSelected={filterSelected || {}}
          priceLimit={priceLimit}
          ordination={ordination}
          showZipCode={showZipCode}
          expanded
        />
      </div>
    </Fragment>
  )
}

// schema
Sidebar.propTypes = {
  categories: PropTypes.array,
  handleFilterChanged: PropTypes.func.isRequired,
  filterSelected: PropTypes.object,
  priceLimit: PropTypes.object,
  pageType: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  ordination: PropTypes.object,
  showZipCode: PropTypes.bool
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Search/Sidebar.js